/** @format */
import { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

import { SitewideBannerColours, SitewideBannerProps } from './index';

/**
 * Base styles for the sitewide banner component
 *
 * */
const baseStyles = () => css`
    width: 100%;
    display: flex;
    align-items: center;
    padding: var(--layout-spacing-16);
    text-align: center;

    .sitewide-banner-content {
        flex: 1;
        margin-right: var(--layout-spacing-12);
    }

    .sitewide-banner-close {
        margin-left: auto;
    }
`;

/**
 * Colour styles for the sitewide banner component ie FIRE - SOL
 *
 * @param {SitewideBannerProps} colour The sitewide banner properties object
 * */
const colourStyles = ({ colour }: SitewideBannerProps) => {
    switch (colour) {
        case SitewideBannerColours.FLAME:
            return css`
                background-color: var(--colors-brand-secondary);
                color: var(--colors-text-inverse);
                a {
                    text-decoration-color: var(--colors-text-inverse);
                }
            `;
        case SitewideBannerColours.SOL:
        default:
            return css`
                background-color: var(--colors-brand-accent);
                color: var(--colors-text-secondary);
                a {
                    text-decoration-color: var(--colors-text-secondary);
                }
            `;
    }
};

/**
 * Small tablet styles for the sitewide banner component
 *
 * */
const smallTabletStyles = () => css`
    align-items: unset;
    text-align: left;

    .sitewide-banner-close {
        align-items: flex-start;
    }
`;

/**
 * The sitewide banner component styles
 *
 * @param {SitewideBannerProps} props The sitewide banner properties object
 * */
export const styles = (props: SitewideBannerProps) => css`
    ${baseStyles()}
    ${colourStyles(props)}
    ${smallTablet(smallTabletStyles())}
`;
